import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=2987905b&scoped=true&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"
import style0 from "./patients.vue?vue&type=style&index=0&id=2987905b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987905b",
  null
  
)

export default component.exports